module.exports = __webpack_public_path__ + "static/media/logo.450f79e2.svg";